import { Injectable } from '@angular/core';

@Injectable()
export class ErrorHandler {
    
	constructor() { }

	handle(response) {
		if(response.status!=undefined) {
			if(response.status == 401 || response.status == 403){
				console.log("Unauthorised : "+response);
				window.location.href = "/#/extra/login";
			}else if(response.status == 404){
				console.log("Forbidden : "+response);
				window.location.href = "/#/extra/404";
			}else if(response.status == 500){
				console.log("Server Exception : "+response);
				window.location.href = "/#/extra/500";
			}
		}
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/error-handler.service.ts